import React, { useEffect, useState } from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Paper, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";  // Import useNavigate from react-router-dom

const OrderDetails = () => {
  const [orderDetails, setOrderDetails] = useState([]);
  const navigate = useNavigate();  // Initialize navigate
  
  useEffect(() => {
    fetchOrderDetails();
  }, []);

  const fetchOrderDetails = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}orders/order-history/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setOrderDetails(response.data.orders);
      })
      .catch((error) => {
        console.error("Failed to fetch order details", error);
        alert("Failed to fetch order details.");
      });
  };

  const handleDownloadFile = (labelClaimId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("You are not authenticated. Please login first.");
      return;
    }

    // Correct the download URL to use the labelClaimId
    const downloadUrl = `${process.env.REACT_APP_API_BASE_URL}/orders/download/${labelClaimId}`;
    // Use axios to handle the file download
    axios
      .get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // Important to handle the file as a blob
      })
      .then((response) => {
        // Create a link element to trigger the download
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${labelClaimId}.xlsx`; // Use the labelClaimId as the file name
        link.click(); // Trigger the download
      })
      .catch((error) => {
        console.error("Failed to download file", error);
        alert("There was an error while downloading the file. Please try again.");
      });
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", marginBottom: "20px" }}>
        Order History
      </Typography>

      {orderDetails && orderDetails.length > 0 ? (
        <Paper sx={{ padding: "20px", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Order ID</TableCell>
                <TableCell>Label Claim</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Payment Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderDetails.map((order) => (
                <TableRow key={order.id} hover>
                  <TableCell>{order.id}</TableCell>
                  <TableCell>{order.label_claim}</TableCell>
                  <TableCell>${order.amount}</TableCell>
                  <TableCell>{order.payment_status === "completed" ? "Paid" : "failed"}</TableCell>
                  <TableCell>
                    {order.payment_status === "completed" ? (
                      <Tooltip title="Download Dossier" arrow>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleDownloadFile(order.label_claim_id)} // Pass the correct labelClaimId
                        >
                          Download
                        </Button>
                      </Tooltip>
                    ) : (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => navigate(`/dashboard/`)} // Using navigate correctly
                      >
                        Retry Order again
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ) : (
        <Typography variant="h6" color="textSecondary">
          No orders found.
        </Typography>
      )}
    </div>
  );
};

export default OrderDetails